/**
 * What the Settle affordance offers on one thread.
 *
 * The card's hover slot, the archived row's restore control, and the
 * right-click menu all answer this question, and each used to answer it in its
 * own `if`. They drifted: the card grew a `!isThreadRunning` clause the menu
 * never had, so a Working thread showed no hover control while the menu still
 * offered "Settle thread" — and `settleThread` then rejected the click. One
 * function, three call sites, no way to disagree.
 *
 * CMMD owns this filing state, so runtime capability and execution status are
 * not inputs. Settling a working thread moves the row and does not stop work.
 */

export type ThreadSettleAvailability = "settle" | "unsettle" | "none";

export interface ThreadSettleAvailabilityInput {
  /** A CMMD archive operation owns disposition changes while present. */
  readonly archiveState?: "requested" | "applying" | "archived" | "failed" | null | undefined;
  /** Whether this thread is already on the Settled shelf. */
  readonly isSettled?: boolean | undefined;
  /** Whether this surface owns an un-settle handler at all. */
  readonly canUnsettle?: boolean | undefined;
}

export function resolveThreadSettleAvailability(
  input: ThreadSettleAvailabilityInput,
): ThreadSettleAvailability {
  if (input.archiveState != null) return "none";
  if (input.isSettled !== true) return "settle";
  return input.canUnsettle === false ? "none" : "unsettle";
}
